import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Table,
  Row,
  Col,
  FormControl,
  Form,
  Accordion,
} from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FaEdit, FaFileExport, FaPlus, FaTrashAlt } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { BASE_URL, HEADERS } from "../../utils/constant";
import ApplyLeaveModal from "../../components/Modals/LeaveModel";
import AssignLeaveModal from "../../components/Modals/AssignLeavesModel";
import { Link } from "react-router-dom";
import NoData from "../../components/NoData";
import Loader from "../../components/Loader";
import { useCommonContext } from "../../utils/context";
import LeaveViewModal from "../../components/Modals/HisstoryModals/LeaveViewModel";
import ExportModal from "../../components/Modals/ExportsModel/main";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";
import StatusBadge from "../../components/StatusBadge";

const LeaveReport = () => {
  const [leaves, setLeaves] = useState([]);
  const [showApplyLeaveModal, setShowApplyLeaveModal] = useState(false);
  const [editLeaveData, setEditLeaveData] = useState(null);
  const [isUpdateStatus, setIsUpdateStatus] = useState(false);
  const [showAssignLeaveModal, setShowAssignLeaveModal] = useState(false);
  const { toggled } = useCommonContext();
  const [searchTerm, setSearchTerm] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const role = localStorage.getItem("role");
  const userPermissions = localStorage.getItem("user_permissions");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = localStorage.getItem("userId");

  const [itemOffset, setItemOffset] = useState(0);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = leaves.slice(itemOffset, endOffset);

  const { user } = useCommonContext();

  const [itemuserOffset, setItemuserOffset] = useState(0);
  const [currentuserPage, setCurrentuserPage] = useState(1);
  const [totaluserPages, setTotaluserPages] = useState(0);
  const [itemsuserPerPage, setItemsuserPerPage] = useState("all");
  const enduserOffset = itemuserOffset + itemsuserPerPage;
  const currentuserItems = users.slice(itemuserOffset, enduserOffset);

  const [showViewModal, setShowViewModal] = useState(false);
  useEffect(() => {
    fetchUsers(currentuserPage);
  }, [searchUser, currentuserPage, itemsuserPerPage]);

  useEffect(() => {
    setCurrentuserPage(1);
  }, [searchUser]);

  const fetchUsers = async (page = 1) => {
    setLoading(true);
    try {
      const url = `${BASE_URL}/users/tms_users/user_leave_data/`;
      const params = {
        page: page,
        page_size: itemsuserPerPage,
      };
      if (searchUser) params.search = searchUser;
      const response = await axios.get(url, {
        headers: HEADERS,
        params: params,
      });

      if (response.data && response.data) {
        setUsers(response.data.results || []);
        setTotaluserPages(Math.ceil(response.data.total_pages));
        setCurrentuserPage(page);
      } else {
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleuserPageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentuserPage(newPage);
  };

  const handleuserItemsPerPageChange = (e) => {
    const value = e.target.value === "all" ? "all" : Number(e.target.value);
    setItemsuserPerPage(value);

    setCurrentuserPage(1);
  };

  useEffect(() => {
    fetchLeaves(currentPage);
  }, [currentPage, itemsPerPage, searchTerm, statusFilter, dateFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter, dateFilter]);

  const fetchLeaves = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        page: page,
        page_size: itemsPerPage,
      };

      if (searchTerm) params.search = searchTerm;
      if (statusFilter) params.status = statusFilter;

      if (role === "superuser") {
        params.exclude_user = userId;
      }

      const response = await axios.get(`${BASE_URL}/users/leaves/`, {
        headers: HEADERS,
        params: params,
      });

      if (response.data) {
        setLeaves(response.data.results || []);
        setTotalPages(Math.ceil(response.data.total_pages));
        setCurrentPage(page);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchLeaves(1);
      } else {
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleApplyLeave = () => {
    setEditLeaveData(null);
    setIsUpdateStatus(false);
    setShowApplyLeaveModal(true);
  };

  const handleEditLeave = (leave) => {
    setEditLeaveData(leave);
    setIsUpdateStatus(false);
    setShowApplyLeaveModal(true);
  };

  const handleUpdateStatus = (leave) => {
    setEditLeaveData(leave);
    setIsUpdateStatus(true);
    setShowApplyLeaveModal(true);
  };

  const handleViewLeave = (leave) => {
    setSelectedLeave(leave);
    setShowViewModal(true);
  };

  const handleDeleteLeave = async (leaveId) => {
    try {
      await axios.delete(`${BASE_URL}/users/leaves/${leaveId}`, {
        headers: HEADERS,
      });
      toast.success("Leave deleted successfully.");
      setLeaves(leaves.filter((leave) => leave.id !== leaveId));
      fetchLeaves(currentPage);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };

  const calculateDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
  };

  return (
    <div className="container-fluid ">
      <Row>
        <Col lg={7} xs={12}>
          <div className="mt-3 d-flex container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
            <h4 className="mb-md-0">Leave Report</h4>

            <div
              className="d-none d-md-flex align-items-center gap-2"
              style={{ flexWrap: "nowrap" }}
            >
              {userPermissions.includes("leavereport_apply_leave") && (
                <CommonButton
                  className="uniform-button d-flex align-items-center justify-content-center"
                  onClick={handleApplyLeave}
                  style={{
                    flex: "0 1 auto",
                    minWidth: "140px",
                    whiteSpace: "nowrap",
                    padding: "6px 12px",
                  }}
                >
                  <FaPlus style={{ marginRight: "6px" }} />
                  <span style={{ whiteSpace: "nowrap" }}>Apply Leave</span>
                </CommonButton>
              )}

              {userPermissions.includes("leavereport_assign_leave") && (
                <CommonButton
                  className="uniform-button d-flex align-items-center justify-content-center"
                  onClick={() => setShowAssignLeaveModal(true)}
                  style={{
                    flex: "0 1 auto",
                    minWidth: "140px",
                    whiteSpace: "nowrap",
                    padding: "6px 12px",
                  }}
                >
                  <FaPlus style={{ marginRight: "6px" }} />
                  <span style={{ whiteSpace: "nowrap" }}>Assign Leave</span>
                </CommonButton>
              )}

              <CommonButton
                className="uniform-button d-flex align-items-center justify-content-center"
                onClick={() => setShowExportModal(true)}
                disabled={currentItems.length === 0}
                style={{
                  flex: "0 1 auto",
                  minWidth: "130px",
                  whiteSpace: "nowrap",
                  padding: "6px 12px",
                }}
              >
                <FaFileExport style={{ marginRight: "6px" }} />
                <span style={{ whiteSpace: "nowrap" }}>Export</span>
              </CommonButton>
            </div>

            <div className="d-md-none w-100 mt-2">
              <Accordion flush>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Filters & Actions</Accordion.Header>
                  <Accordion.Body className="pt-3">
                    <div className="d-flex flex-wrap gap-2 justify-content-start">
                      {userPermissions.includes("leavereport_apply_leave") && (
                        <CommonButton
                          className="uniform-button flex-grow-1 flex-md-grow-0"
                          style={{ minWidth: "120px" }}
                          onClick={handleApplyLeave}
                        >
                          Apply Leave
                        </CommonButton>
                      )}

                      {userPermissions.includes("leavereport_assign_leave") && (
                        <CommonButton
                          className="uniform-button flex-grow-1 flex-md-grow-0"
                          style={{ minWidth: "120px" }}
                          onClick={() => setShowAssignLeaveModal(true)}
                        >
                          Assign Leave
                        </CommonButton>
                      )}

                      <CommonButton
                        className="uniform-button flex-grow-1 flex-md-grow-0 d-flex align-items-center justify-content-center"
                        style={{ minWidth: "120px" }}
                        onClick={() => setShowExportModal(true)}
                        disabled={currentItems.length === 0}
                      >
                        <FaFileExport className="me-2" /> Export
                      </CommonButton>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>

          <>
            <Row className="align-items-center">
              <Col md={4}>
                <FormControl
                  type="text"
                  placeholder="Search Here..."
                  className="uniform-input search-text"
                  disabled={leaves?.length === 0 && !searchTerm}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </Col>

              <Col md={4}>
                <Form.Select
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  disabled={leaves?.length === 0 && !statusFilter}
                  className="uniform-input"
                >
                  <option value="">All Status</option>
                  <option value="Submitted">Submitted</option>
                  <option value="Approved">Approved</option>
                  <option value="Rejected">Rejected</option>
                </Form.Select>
              </Col>
            </Row>

            <div
              className={`table-responsive ${
                currentItems.length === 0 ? "" : "tabell"
              } mb-0`}
              style={{ height: "73vh" }}
            >
              {loading ? (
                <Loader />
              ) : currentItems.length > 0 ? (
                <table className="table   tstart">
                  <thead className="thead">
                    <tr style={{ whiteSpace: "nowrap" }}>
                      {/* <th style={{ width: "100px" }}>S.No</th> */}
                      <th style={{ width: "250px" }}>Name</th>
                      <th style={{ width: "150px" }}>Phone No.</th>
                      <th style={{ width: "150px" }}>Role</th>
                      <th style={{ width: "150px" }}>Leave Type</th>
                      <th style={{ width: "200px" }}>From Date</th>
                      <th style={{ width: "200px" }}>To Date</th>
                      <th style={{ width: "80px" }}>Days</th>
                      <th style={{ width: "250px" }}>Reason</th>
                      <th style={{ width: "200px" }}>Status</th>
                      <th style={{ width: "200px" }}>Remark</th>
                      <th style={{ width: "100px" }}></th>
                      <th style={{ width: "150px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems?.map((leave, index) => (
                      <tr
                        key={leave.id}
                        onClick={() => handleViewLeave(leave)}
                        className="tbody"
                      >
                        <td
                          title={`${leave.userId.first_name} ${leave.userId.last_name}`}
                        >
                          <div className="d-flex align-items-center">
                            <span
                              className="badge bg-primary text-white me-2"
                              title={`User ID: ${leave.userId.id}`}
                            >
                              {leave.userId.id}
                            </span>
                            <div className="tdsubject">
                              {`${leave.userId.first_name} ${leave.userId.last_name}`}
                            </div>
                          </div>
                        </td>

                        <td title={leave.userId.phone_number}>
                          <div className="tdsubject">
                            {leave.userId.phone_number}
                          </div>
                        </td>

                        <td title={leave.userId.role}>
                          <div className="tdsubject badge bg-secondary text-white">
                            {leave.userId.role === "superuser"
                              ? "Manager"
                              : leave.userId.role === "agent"
                                ? "Executive"
                                : leave.userId.role}
                          </div>
                        </td>

                        <td title={leave.leave_type}>
                          <div className="tdsubject">{leave.leave_type}</div>
                        </td>

                        <td
                          title={new Date(
                            leave.start_date,
                          ).toLocaleDateString()}
                        >
                          <div className="tdsubject">
                            {new Date(leave.start_date).toLocaleDateString()}
                          </div>
                        </td>

                        <td
                          title={new Date(leave.end_date).toLocaleDateString()}
                        >
                          <div className="tdsubject">
                            {new Date(leave.end_date).toLocaleDateString()}
                          </div>
                        </td>

                        <td
                          title={`${calculateDays(
                            leave.start_date,
                            leave.end_date,
                          )} days`}
                        >
                          <div className="tdsubject">
                            {calculateDays(leave.start_date, leave.end_date)}
                          </div>
                        </td>

                        <td title={leave.reason}>
                          <div className="tdsubject">{leave.reason}</div>
                        </td>

                        <td>
                          <StatusBadge status={leave.status} />
                        </td>

                        <td
                          title={
                            leave.status === "Approved"
                              ? leave.approved_remark || "—"
                              : leave.rejected_remark || "—"
                          }
                        >
                          <div className="tdsubject">
                            {leave.status === "Approved"
                              ? leave.approved_remark || "—"
                              : leave.rejected_remark || "—"}
                          </div>
                        </td>

                        <td style={{ padding: "6px 10px" }}>
                          <div className="d-flex justify-content-center ">
                            {leave.status === "Submitted" && (
                              <>
                                {userPermissions.includes(
                                  "leavereport_change_leavereport",
                                ) && (
                                  <FaEdit
                                    size={15}
                                    className="me-3 cursor-pointer text-primary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleEditLeave(leave);
                                    }}
                                  />
                                )}
                                {userPermissions.includes(
                                  "leavereport_delete_leavereport",
                                ) && (
                                  <FaTrashAlt
                                    size={15}
                                    className="text-danger"
                                    style={{ cursor: "pointer" }}
                                    title="Delete Leave"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteLeave(leave.id);
                                    }}
                                  />
                                )}
                              </>
                            )}
                          </div>
                        </td>
                        <td style={{ padding: "6px 10px" }}>
                          <div className="d-flex justify-content-center ">
                            {leave.status === "Submitted" && (
                              <>
                                {userPermissions.includes(
                                  "leavereport_update_status",
                                ) && (
                                  <Button
                                    variant="success"
                                    size="sm"
                                    title="Update Status"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleUpdateStatus(leave);
                                    }}
                                  >
                                    Update Status
                                  </Button>
                                )}
                              </>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <NoData message="No Data Found" height="400px" />
              )}
            </div>

            {currentItems.length > 0 && (
              <Pagination
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                handlePageClick={handlePageClick}
                handleItemsPerPageChange={handleItemsPerPageChange}
              />
            )}
          </>
        </Col>

        <Col xs={12} md={6} lg={5}>
          <Card className="shadow-sm border-0 user-leave-card mt-3">
            <div className="bg-primary text-white d-flex align-items-center justify-content-between p-3 rounded-top">
              <h5 className="mb-0 fw-semibold">User Leave Data</h5>
              <i className="fas fa-calendar-check fs-5"></i>
            </div>

            <Card.Body className="p-3">
              <Row className="align-items-center mb-3 g-2">
                <Col xs={12} sm={5} md={4}>
                  <Form.Group
                    controlId="recordsPerPage"
                    className="d-flex align-items-center"
                  >
                    <Form.Label className="me-2 mb-0 small text-muted">
                      Show
                    </Form.Label>
                    <Form.Select
                      size="sm"
                      value={itemsuserPerPage}
                      onChange={handleuserItemsPerPageChange}
                      className="fw-semibold"
                      style={{ maxWidth: "100px" }}
                    >
                      <option value="all">All</option>
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={12} sm={7} md={8}>
                  <div className="search-wrapper position-relative">
                    <FormControl
                      type="text"
                      placeholder="Search user..."
                      value={searchUser}
                      onChange={(e) => setSearchUser(e.target.value)}
                      className="search-input"
                    />
                  </div>
                </Col>
              </Row>

              {loading ? (
                <Loader />
              ) : users.length === 0 ? (
                <NoData message="No Data Found" height="350px" />
              ) : (
                <div
                  className="table-responsive compact-table"
                  style={{ maxHeight: "70vh" }}
                >
                  <table className="table align-middle table-hover text-center">
                    <thead className="table-light sticky-top">
                      <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <th>CL</th>
                        <th>SL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user) => (
                        <tr key={user.id}>
                          <td className="text-start">
                            <div className="d-flex align-items-center">
                              <span className="badge bg-primary me-2">
                                {user.id}
                              </span>
                              <span
                                className="fw-medium tdsubject"
                                title={`${user.first_name} ${user.last_name}`}
                              >
                                {user.first_name} {user.last_name}
                              </span>
                            </div>
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                user.role === "agent"
                                  ? "bg-info"
                                  : user.role === "superuser"
                                    ? "bg-success"
                                    : "bg-secondary"
                              }`}
                            >
                              {user.role === "agent"
                                ? "Executive"
                                : user.role === "superuser"
                                  ? "Manager"
                                  : user.role || "N/A"}
                            </span>
                          </td>
                          <td>{user.allocated_casual_leave || "0"}</td>
                          <td>{user.allocated_sick_leave || "0"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {currentuserItems.length > 0 && (
                <div className="mt-3 d-flex justify-content-center">
                  <ReactPaginate
                    previousLabel={<MdArrowBackIos />}
                    nextLabel={<MdArrowForwardIos />}
                    breakLabel={<span className="dots">...</span>}
                    pageCount={totaluserPages}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={3}
                    onPageChange={handleuserPageClick}
                    containerClassName="pagination justify-content-center mb-0"
                    activeClassName="active"
                    previousClassName="page-item"
                    nextClassName="page-item"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>

        <ExportModal
          show={showExportModal}
          handleClose={() => setShowExportModal(false)}
          title="leaves"
        />

        {showApplyLeaveModal && (
          <ApplyLeaveModal
            show={showApplyLeaveModal}
            handleClose={() => setShowApplyLeaveModal(false)}
            leaveData={editLeaveData}
            onApplyLeave={() => fetchLeaves(currentPage)}
            isUpdateStatus={isUpdateStatus}
            fetchuserleave={fetchUsers}
          />
        )}

        <AssignLeaveModal
          show={showAssignLeaveModal}
          handleClose={() => setShowAssignLeaveModal(false)}
          fetchLeaves={() => fetchLeaves(currentPage)}
        />

        <LeaveViewModal
          show={showViewModal}
          handleClose={() => setShowViewModal(false)}
          leaveId={selectedLeave?.id}
          leave={selectedLeave}
          currentPage={currentPage}
        />
      </Row>
    </div>
  );
};

export default LeaveReport;
